import styled from 'styled-components';
import { Button, Col } from 'antd';

export const TableWrapper = styled(Col)`
	.ant-table-thead {
		user-select: none;
	}
`;

export const TlidLink = styled(Button)`
	padding: 0;
	color: ${({ theme }) => theme.palette.primary.default};
	text-decoration: underline;

	&:hover,
	&:focus {
		color: ${({ theme }) => theme.palette.primary[600]};
		text-decoration: underline;
	}
`;
